/**
 * Currency helpers shared by every `ShippingModal` call site. Formatting
 * lives here (not in the modal) so the modal receives ready-made strings
 * and stays presentational.
 *
 * Drops the `.00` tail on whole dollars — matches Figma 703:28734
 * ("$25", not "$25.00").
 */
export function formatMoney(n: number): string {
  if (!Number.isFinite(n)) return '—';
  return Number.isInteger(n) ? `$${n}` : `$${n.toFixed(2)}`;
}

/**
 * `$min - $max`, collapsing to a single value when the two are equal so
 * we never render "$10 - $10". Note the spaces around the dash — Figma
 * 703:28734.
 */
export function formatMoneyRange(min: number, max: number): string {
  if (Math.abs(min - max) < 0.01) return formatMoney(min);
  return `${formatMoney(min)} - ${formatMoney(max)}`;
}
